import { BlindType } from '@pairy/sheard/types';

interface GetBlindPagesProps {
  blindStatus?: BlindType;
  blindPage?: number;
  totalPages?: number;
}

export const getBlindPages = ({
  blindStatus,
  blindPage,
  totalPages,
}: GetBlindPagesProps) => {
  if (!blindStatus || !blindPage || !totalPages) {
    return null;
  }

  if (blindStatus === 'none') {
    return null;
  }

  if (blindStatus === 'specific') {
    return [blindPage];
  }

  if (blindStatus === 'startFrom') {
    return Array.from(
      { length: totalPages - blindPage + 1 },
      (_, i) => blindPage + i,
    );
  }

  return null;
};
